import { Pill } from '@eventbrite/eds-pill';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import {
    UrgencySignals,
    UrgencySignalsMessages,
} from '../../../models/urgencySignals';
import './TicketRemainingTicketsStyles.scss';

export interface TicketRemainingUrgencySignalProps {
    className?: Parameters<typeof classNames>[0];
    isSoldOut?: boolean;
    numTicketsRemaining: number | null;
    urgencySignals: UrgencySignals | null;
}
export const TicketRemainingUrgencySignal: FunctionComponent<
    TicketRemainingUrgencySignalProps
> = ({ isSoldOut, numTicketsRemaining, className, urgencySignals }) => {
    if (!isSoldOut && !numTicketsRemaining) {
        return null;
    }

    const content = isSoldOut
        ? gettext('Sold out')
        : gettext('%(numTicketsRemaining)s Remaining', {
              numTicketsRemaining,
          });

    const { color = 'grey', testId } = urgencySignals?.sortedMessages.some(
        (value) => value === UrgencySignalsMessages.fewTickets,
    )
        ? { color: 'red', testId: 'remaining-tickets-red' }
        : { color: 'grey', testId: 'remaining-tickets-grey' };

    return (
        <Pill
            className={classNames(
                'ticket-remaining-tickets-pill',
                {
                    'ticket-remaining-tickets-pill--sold-out': isSoldOut,
                },
                className,
            )}
            dataTestid={testId}
            color={color}
        >
            {content}
        </Pill>
    );
};

export default TicketRemainingUrgencySignal;
